import React, { useState, useEffect } from "react";
import logo from "../asset/logo-main.png";
import sgb from "../asset/sgb.png";
import facebook from "../asset/facebook.png";
import twitter from "../asset/twitter.png";
import instagram from "../asset/instagram.png";
import youtube from "../asset/youtube.png";
import linkedin from "../asset/linkedin.png";

import axios from "axios";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

// verify otp
// async function VerifyOtp(credentials) {
//   debugger;
//   return fetch(`${process.env.REACT_APP_LOGINPAGE}guest/verifyotp`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(credentials),
//   }).then((data) => data.json());
// }

//userlogin
async function Userlogin(credentials) {
  debugger;
  return fetch(`${process.env.REACT_APP_LOGINPAGE}Client/UserLogin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  }).then((data) => data.json());
}

//SENDOTP
// async function SendOtp(credentials) {
//   debugger;
//   return fetch(
//     `${process.env.REACT_APP_LOGINPAGE}guest/requestotp_smsEmail`,
//     // `http://localhost:60443/api/guest/requestotp_smsEmail`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(credentials),
//     }
//   ).then((data) =>
//     data.json(
//       Swal.fire(
//         "OTP has been sent on your registered EmailId as well as Mobile Number."
//       )
//     )
//   );
// }

const Login = () => {
  const pdfUrl =
    process.env.REACT_APP_SGB_URL +
    "/asset/Terms and conditions for Sovereign Gold Bonds.pdf";
  const navigate = useNavigate();
  const [clientCode, setclientCode] = useState();
  const [password, setpassword] = useState();
  const [mobileno, setMobileno] = useState();
  const [emailid, setEmailid] = useState();
  const [clientname, setClientname] = useState();
  const [data, setData] = useState([]);
  const application = "PLSGB";
  const otptype = "BOTH";
  const diffotpfor_emailsms = "false";

  //handle submit
  const handleSubmit = async (e) => {
    debugger;
    if (clientCode !== undefined && password !== undefined) {
      e.preventDefault();

      function getBrowserName() {
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf("Chrome") != -1) {
          return "Chrome";
        } else if (userAgent.indexOf("Firefox") != -1) {
          return "Firefox";
        } else if (userAgent.indexOf("Safari") != -1) {
          return "Safari";
        } else if (userAgent.indexOf("Edge") != -1) {
          return "Edge";
        } else if (
          userAgent.indexOf("MSIE") != -1 ||
          userAgent.indexOf("Trident") != -1
        ) {
          return "Internet Explorer";
        } else {
          return "Unknown Browser";
        }
      }

      //define parameters for userlogin
      let Username = clientCode;
      let Password = password;
      let Application = "PLSGB";
      let broswer = getBrowserName();
      debugger;
      const result = await Userlogin({
        Username,
        Password,
        Application,
        broswer,
      });
      debugger;
      const obj_temp = JSON.parse(result);
      const obj = obj_temp["Table"][0];
      if (obj.RESULT == "MULTIPLECLIENTS_WITH_SAME_MOBILENO") {
        new swal({
          title: "Error",
          text: "MULTIPLECLIENTS WITH SAME MOBILE NUMBER. KINDLY LOGIN THROUGH CLIENT CODE",
          icon: "error",
          button: "OK",
        });
        document.getElementById("username").value = "";
      } else if (obj.RESULT != "INVALID") {
        localStorage.setItem("clientCode", JSON.stringify(obj.username));
        localStorage.setItem("token", JSON.stringify(obj.TOKEN));
        navigate("/sgbdetails");
        // setMobileno(obj.Mobileno);
        // setEmailid(obj.Emailid);
        // setClientname(obj.clientname);

        //console.log(mobileno, emailid, clientname);

        // await handleresendotp(
        //   application,
        //   obj.Mobileno,
        //   obj.Emailid,
        //   otptype,
        //   diffotpfor_emailsms,
        //   obj.clientname
        // );
      } else if (obj.RESULT == "INVALID") {
        new swal({
          title: "Error",
          text: "Ivalid credentials. Please try again",
          icon: "error",
          button: "OK",
        });
      }

      // const response = SendOtp(application, mobileno, emailid, clientname);
    } else {
      Swal.fire("Please provide all the required information");
    }
  };

  //handle verifier for otp
  const handleverifier = async (e) => {
    debugger;
    if (clientCode !== undefined) {
      e.preventDefault();
      const response = await VerifyOtp({ otp, mobileno, emailid });
      //console.log("response for verifying otp", response);
      if (response == "VALIDOTP") {
        navigate("/sgbdetails");
      } else {
        new swal({
          title: "Error",
          text: "Invalid Otp",
          icon: "error",
          button: "OK",
        });
      }
    } else {
      Swal.fire("Please provide all the required information");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  const handleresendotp = async (
    application,
    mobileno,
    emailid,
    otptype,
    diffotpfor_emailsms,
    clientname
  ) => {
    debugger;
    if (clientCode !== undefined) {
      const otp_result = await SendOtp({
        application,
        mobileno,
        emailid,
        otptype,
        diffotpfor_emailsms,
        clientname,
      });
    } else {
      Swal.fire("Please provide all the required information");
    }
  };

  const handleForgotPassword = (e) => {
    debugger;
    if (clientCode !== undefined) {
      fetch(process.env.REACT_APP_LOGINPAGE + "sso/ForgotPassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({ Username: clientCode }),
      })
        .then((response) => response.json())
        .then((data) => {
          debugger;
          if (data === null || data === "[]") {
            Swal.fire("There is some processing error.");
          } else {
            Swal.fire(data);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      Swal.fire("Login Id is required.");
    }
  };

  const fetchData = async (apiEndpoint, setDataFunction, data, url) => {
    debugger;
    $("#CRloader").show();
    try {
      const response = await axios.post(`${url}${apiEndpoint}`, data);

      let newData = await response.data;
      if (newData.Table1) {
        newData = await response.data.Table1;
      }
      debugger;
      //console.log(newData);
      $("#CRloader").hide();
      setDataFunction(newData);
      //console.log(newData);
    } catch (error) {
      //console.log("error while fetching", error);
    }
  };

  useEffect(() => {
    const display_sgb_data = async () => {
      debugger;
      fetchData(
        "SGB/Ongoing_sgb",
        setData,
        { pflag: "ALL" },
        process.env.REACT_APP_APIURL
      );
    };
    display_sgb_data();
  }, [mobileno]);

  return (
    <div>
      <div class="header">
        <div class="container">
          <div class="logo_s">{<img src={logo} />}</div>
          <div class="rig">
            Need assistance? Call us: <span>1860 210 2222</span>
          </div>
        </div>
      </div>
      <div class="bg_backgroung">
        <div class="container">
          <div class="flx_add">
            <div class="half_add1">
              <div class="login_form">
                <div class="client_cl active">
                  <div class="lock">
                    <img src={sgb} />
                    <span>Use your PLClients credentials to login</span>
                  </div>

                  <label class="input_form error" id="lblerror"></label>
                  <label>Client Code</label>
                  <label class="icon_user">
                    <input
                      type="text"
                      class="input_form"
                      placeholder="Enter Client Code "
                      id="username"
                      onChange={(e) => setclientCode(e.target.value)}
                    />
                  </label>

                  {/* <div class="submit_cl btn_hover_js">
                    <input
                      type="button"
                      value="Submit"
                      class="submit_btn"
                      onClick={handleSubmit}
                    />
                  </div> */}
                  <label>Password</label>
                  <label class="icon_pass">
                    <input
                      type="password"
                      class="input_form pass"
                      placeholder="Enter password"
                      id="password"
                      onChange={(e) => setpassword(e.target.value)}
                      onKeyDown={handleKeyDown}
                    />
                  </label>

                  {/* <div class="resend" align="right">
                    <input
                      type="button"
                      value="Resend OTP"
                      class="submit_btn btn_hover_js"
                      onClick={() => {
                        handleresendotp(
                          application,
                          mobileno,
                          emailid,
                          otptype,
                          diffotpfor_emailsms,
                          clientname
                        );
                      }}
                    />
                  </div> */}
                  <div class="trm_sec">
                    <a href={pdfUrl} target="_blank">
                      <div class="trms">TERMS AND CONDITION</div>
                    </a>
                  </div>
                  <div class="submit_cl">
                    <div class="forgot_pass">
                      <label>
                        <button
                          onClick={handleForgotPassword}
                          id="forgotpassword"
                        >
                          Forgot Password
                        </button>
                        {/* <a id="forgotpassword">Forgot password?</a> */}
                      </label>
                    </div>
                  </div>
                  <div class="conti_new">
                    <input
                      type="button"
                      value="Submit"
                      class="submit_btn btn_hover_js"
                      onClick={handleSubmit}
                    />
                    {/* <button
                      class="submit_btn btn_hover_js"
                      id="Login"
                      type="submit"
                    >
                      <span>&#10140;</span> Continue
                    </button> */}
                  </div>
                </div>
              </div>
              {/* <div class="text-left faqs_top">
                <a href={pdfUrl} target="_blank">
                  <div class="faqs">TERMS AND CONDITION</div>
                </a>
              </div> */}
            </div>
            <div class="half_add">
              <div class="txt_login">
                <div class="head_txt">
                  <span>Ongoing SGB</span>
                </div>
              </div>

              <div class="tbl_eipo">
                <p class="parra_g">
                  Individual investors must have a PAN issued by the Income Tax
                  Department and a Demat account. While it is not mandatory to
                  have a Trading account, it is advisable to open one to sell
                  the stock once listed.{" "}
                </p>
                {data.some((item) => item.PFLAG === "O") ? (
                  <div class="over">
                    <table class="table_pl">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>SGB Name</th>
                          <th>Subscription Dates</th>
                          <th>Allotment Dates</th>
                        </tr>
                      </thead>
                      <tbody class="tbl_body">
                        {data.map(
                          (item, index) =>
                            item.PFLAG === "O" && (
                              <tr key={index}>
                                <td id="index">{index + 1}</td>
                                <td id="symbolname">{item.NAME}</td>
                                <td id="opendate">{item.BIDDINGSTARTDATE}</td>
                                <td id="allotment">{item.ALLOTMENTDATE}</td>
                              </tr>
                            )
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p class="empty_border">
                    There are no open SGB series at this point
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <div class="container">
          <div class="left_foot">
            <p class="foot_sm" align="left">
              © All rights reserved.
              <a
                class="text-green"
                href="https://www.plindia.com/"
                target="_blank"
              >
                {" "}
                Prabhudas Lilladher Private Limited
              </a>
            </p>
          </div>
          <div class="right_foot soc">
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/PLIndiaOfficial/"
                  target="_blank"
                >
                  <img src={facebook} />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/PLIndiaOnline/" target="_blank">
                  <img src={twitter} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/prabhudaslilladher/"
                  target="_blank"
                >
                  <img src={instagram} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/prabhudaslilladher/"
                  target="_blank"
                >
                  <img src={linkedin} />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/user/prabhudaslilladher"
                  target="_blank"
                >
                  <img src={youtube} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    // <div class="d-md-flex half">
    //   <div class="bg">{/* <img src={logo} className="bg" /> */}</div>
    //   <div class="contents bg_cont">
    //     {/* <img src={bg2} /> */}
    //     <div class="container">
    //       <div class="row align-items-center justify-content-center">
    //         <div class="col-md-12">
    //           <div class="form-block mx-auto">
    //             <div class="text-center mb-4 pl_b">
    //               <h4>
    //                 Use your <br></br>
    //                 <strong> Windows credentials</strong> to login
    //                 <br />
    //               </h4>
    //             </div>
    //             <form action="#" method="post">
    //               <div class="form-group first">
    //                 {/* <label for="username">Enter Client Code</label> */}
    //                 <label>Enter Client Code</label>
    // <input
    //   type="text"
    //   class="form-control"
    //   placeholder="Client Code"
    //   id="username"
    //   onChange={(e) => setclientCode(e.target.value)}
    // />
    //               </div>
    //               <div class="form-group last mb-3">
    //                 {/* <label for="password">Enter OTP</label> */}
    //                 <label>Enter OTP</label>
    //                 <input
    //                   type="password"
    //                   class="form-control"
    //                   placeholder="Otp"
    //                   id="password"
    //                   onChange={(e) => setOtp(e.target.value)}
    //                 />
    //               </div>
    //               <div class="d-sm-flex mb-4 align-items-center">
    //                 <label class="rem_cl">
    //                   <input type="checkbox" /> Remember me
    //                   {/* <input type="checkbox" checked="checked" /> Remember me */}
    //                 </label>
    //                 <span class="ml-auto">
    //                   <a href="#" class="forgot-pass">
    //                     Forgot Password
    //                   </a>
    //                 </span>
    //               </div>
    //               <input
    //                 type="button"
    //                 value="Submit"
    //                 class="btn_submit"
    //                 onClick={handleSubmit}
    //               />
    //               <input
    //                 type="button"
    //                 value="Continue"
    //                 class="continue_btn"
    //                 onClick={handleverifier}
    //               />
    //             </form>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div class="row">
    //     <div class="col-lg-12">
    //       <div class="scroll_data">
    //         <table class="tbl_web">
    //           <thead>
    //             <tr>
    //               <th>SGB Name</th>
    //               <th>Subscription Dates</th>
    //               <th>Allottmnt Dates</th>
    //             </tr>
    //           </thead>
    //           <tbody class="tbl_body">
    //             {data.map(
    //               (item, index) =>
    //                 item.PFLAG === "U" && (
    //                   <tr key={index}>
    //                     <td id="symbolname">{item.NAME}</td>
    //                     <td id="opendate">{item.BIDDINGSTARTDATE}</td>
    //                     <td id="allotment">{item.ALLOTMENTDATE}</td>
    //                   </tr>
    //                 )
    //             )}
    //           </tbody>
    //         </table>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Login;
